import { Component, Input, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';

@Component({
  selector: 'app-dropdown-tags',
  templateUrl: './dropdown-tags.component.html',
  styleUrls: ['./dropdown-tags.component.scss']
})

export class DropdownTagsComponent {
  @Input() tags: string[] = [];
  @Input() disabled = false;
  @Input() id = '';
  @Input() invalid = false;
  @Output() removeTag = new EventEmitter<{tag: string, index: number}>();

  isOpen = false;

  constructor(private eRef: ElementRef) { }

  @HostListener('document:click', ['$event'])
  onClick(ev) {
    if (this.isOpen) {
      if (!this.eRef.nativeElement.contains(ev.target)) {
        this.isOpen = false;
      }
    }
  }

  removeT(tag: string, index: number) {
    this.removeTag.emit({
      tag,
      index
    });
    this.isOpen = false;
  }

  openClose(ev) {
    ev.stopPropagation();
    this.isOpen = !this.isOpen;
  }
}
